var _path, _path2, _rect, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuitCase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83337 8.33333C3.83337 7.41286 4.57957 6.66666 5.50004 6.66666H15.5C16.4205 6.66666 17.1667 7.41286 17.1667 8.33333V8.33333C17.1667 9.71404 16.0474 10.8333 14.6667 10.8333H6.33337C4.95266 10.8333 3.83337 9.71404 3.83337 8.33333V8.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33334C8 4.22877 8.89543 3.33334 10 3.33334H11C12.1046 3.33334 13 4.22877 13 5.33334V6.66667H8V5.33334Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.83337,
    y: 6.66666,
    width: 13.3333,
    height: 10,
    rx: 2,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10V11.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V11.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCase);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjgzMzM3IDguMzMzMzNDMy44MzMzNyA3LjQxMjg2IDQuNTc5NTcgNi42NjY2NiA1LjUwMDA0IDYuNjY2NjZIMTUuNUMxNi40MjA1IDYuNjY2NjYgMTcuMTY2NyA3LjQxMjg2IDE3LjE2NjcgOC4zMzMzM1Y4LjMzMzMzQzE3LjE2NjcgOS43MTQwNCAxNi4wNDc0IDEwLjgzMzMgMTQuNjY2NyAxMC44MzMzSDYuMzMzMzdDNC45NTI2NiAxMC44MzMzIDMuODMzMzcgOS43MTQwNCAzLjgzMzM3IDguMzMzMzNWOC4zMzMzM1oiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTggNS4zMzMzNEM4IDQuMjI4NzcgOC44OTU0MyAzLjMzMzM0IDEwIDMuMzMzMzRIMTFDMTIuMTA0NiAzLjMzMzM0IDEzIDQuMjI4NzcgMTMgNS4zMzMzNFY2LjY2NjY3SDhWNS4zMzMzNFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3QgeD0iMy44MzMzNyIgeT0iNi42NjY2NiIgd2lkdGg9IjEzLjMzMzMiIGhlaWdodD0iMTAiIHJ4PSIyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDEwVjExLjY2NjciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzIDEwVjExLjY2NjciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };